import { useRootStore } from 'stores/RootStore'
import { useMediaPickerContext } from '../MediaPickerContext'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { SectionHeader } from './SectionHeader'
import { GenerateImageDrawer } from 'components/GenerateImageDrawer/GenerateImageDrawer'
import Styles from './Carousels.module.scss'
import { MediaFileCarousel } from './MediaFileCarousel'
import { TRENDING_EXAMPLES } from 'components/GenerateImageModal/GenerateImageModal'
import { Pressable } from '@react-aria/interactions'
import { AI } from 'blaze-ui/icons'

export const Ai = () => {
  const { handleUpload } = useMediaPickerContext()
  const { openDrawer } = useRootStore().drawersStore

  const openGenerateDrawer = () => {
    openDrawer(GenerateImageDrawer, {
      onUse: async (img) => {
        const response = await fetch(img.url)
        const blob = await response.blob()
        const file = new File([blob], 'AI Generated Image', { type: img.mimeType })
        handleUpload([file])
      },
    })
  }

  const trendingExamplesMediaFiles = TRENDING_EXAMPLES.map((trendingExample) => ({
    id: trendingExample.imageUrl,
    source_url: trendingExample.imageUrl,
    mime_type: 'image/png',
    variants: [],
  }))

  return (
    <MobileWizard.Section gap={8}>
      <SectionHeader title="Generate with AI" onPress={openGenerateDrawer} />
      <div className={Styles.sectionContainer}>
        <MediaFileCarousel mediaFiles={trendingExamplesMediaFiles} provider="hardcodedAi" needsDownload>
          <Pressable onPress={openGenerateDrawer}>
            <div className={Styles.aiCard}>
              <AI size={24} color="var(--selected-fill)" />
              <span>Create your own</span>
            </div>
          </Pressable>
        </MediaFileCarousel>
      </div>
    </MobileWizard.Section>
  )
}
